var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.getYears.length > 0
      ? _c(
          "ul",
          {
            staticClass: "nav nav-tabs",
            attrs: { id: "myTab", role: "tablist" }
          },
          _vm._l(_vm.getYears, function(year, index) {
            return _c(
              "li",
              {
                key: year,
                staticClass: "nav-item",
                attrs: { role: "presentation" }
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "nav-link",
                    class: index === 0 ? "active" : "",
                    attrs: {
                      id: _vm.getYearButtonId(year),
                      "data-bs-toggle": "tab",
                      "data-bs-target": _vm.getTarget(year),
                      type: "button",
                      role: "tab",
                      "aria-controls": _vm.getTabId(year),
                      "aria-selected": index === 0
                    }
                  },
                  [
                    _vm._v(
                      "\n                " + _vm._s(year) + "\n            "
                    )
                  ]
                )
              ]
            )
          }),
          0
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.getYears.length > 0
      ? _c(
          "div",
          { staticClass: "tab-content", attrs: { id: "priceTabContent" } },
          _vm._l(_vm.getYears, function(year, index) {
            return _c(
              "div",
              {
                key: year,
                staticClass: "tab-pane fade",
                class: index === 0 ? "show active" : "",
                attrs: {
                  id: _vm.getTabId(year),
                  role: "tabpanel",
                  "aria-labelledby": _vm.getTabAreaLabel(year)
                }
              },
              [
                _c(
                  "table",
                  { staticClass: "table pricelist-table table-hover" },
                  _vm._l(_vm.yearlyPrices, function(sg) {
                    return _c(
                      "tbody",
                      { key: sg.service._id },
                      _vm._l(sg.lines, function(price) {
                        return _vm.isDateInRange(
                          price.fromdate,
                          price.tilldate,
                          year
                        )
                          ? _c(
                              "tr",
                              { key: price.sourceId, staticClass: "subrow" },
                              [
                                _c("td", { staticClass: "subinfo" }, [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.getFormattedDate(price.fromdate)
                                      ) +
                                      " - " +
                                      _vm._s(
                                        _vm.getFormattedDate(price.tilldate)
                                      ) +
                                      "\n                            "
                                  ),
                                  _c("br"),
                                  _c("small", [_vm._v(_vm._s(price.season))])
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-end calc" }, [
                                  sg.service.calculation === "FLAT"
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.voMsg("tpl.service.FLAT"))
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  sg.service.calculation === "NIGHT"
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.voMsg("tpl.service.NIGHT"))
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  sg.service.calculation === "WEEK"
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.voMsg("tpl.service.WEEK"))
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  sg.service.calculation === "MONTH"
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.voMsg("tpl.service.MONTH"))
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  sg.service.calculation === "USAGE"
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.voMsg("tpl.service.USAGE"))
                                        )
                                      ])
                                    : _vm._e()
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-end price" }, [
                                  price.value
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.getCalculatedPrice(price.value)
                                          )
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  sg.service.calculation === "USAGE"
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.voMsg("tpl.service.USAGE"))
                                        )
                                      ])
                                    : _vm._e()
                                ])
                              ]
                            )
                          : _vm._e()
                      }),
                      0
                    )
                  }),
                  0
                )
              ]
            )
          }),
          0
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.hasGlobalPrices
      ? _c(
          "table",
          { staticClass: "table pricelist-table table-hover mb-3" },
          _vm._l(_vm.globalPrices, function(sg) {
            return _c("tbody", { key: sg.service._id }, [
              _c("tr", [
                _c("td", [
                  _vm._v(
                    "\n                    " +
                      _vm._s(sg.service.name) +
                      "\n                    "
                  ),
                  !sg.service.mandatory
                    ? _c("span", [
                        _vm._v(
                          "(" + _vm._s(_vm.voMsg("tpl.text.optional")) + ")"
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  sg.service.mandatory
                    ? _c("span", [_c("sup", [_vm._v("*")])])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "text-end" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.voMsg("tpl.service." + sg.service.calculation))
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "text-end price" }, [
                  _c("span", [_vm._v(_vm._s(_vm.getCalculatedPrice(sg.price)))])
                ])
              ])
            ])
          }),
          0
        )
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "hint" }, [
      _c("sup", [_vm._v("*")]),
      _vm._v(_vm._s(_vm.voMsg("tpl.text.priceObligatory")))
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }